import { Outlet, Link } from "react-router-dom";
import styles from "./Layout.module.css";
import useToken from '../loginnew/useToken';
import { publicClientApp } from "../../config/msal-config";

/**
 * Represents the layout component of the application.
 * It provides a common structure for all pages and handles the logout functionality.
 */
const Layout = () => {
    /**
     * Handles the logout functionality.
     * Removes the token and session ID from local storage and reloads the page.
     */
    const handleLogout = () => {
        localStorage.removeItem('token-gpt-app');
        localStorage.removeItem('session-id');
        window.location.reload();
        publicClientApp.logout();

    }

    const { token, setToken } = useToken();

    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}>
                <div className={styles.headerContainer}>
                    <Link to="/" className={styles.headerTitleContainer}>
                        <h3 className={styles.headerTitle}>Knowledge AI</h3>
                    </Link>
                    <nav>
                        <ul className={styles.headerNavList}>
                        {
                            token ?
                                (<nav>
                                    <ul className={styles.headerNavList}>
                                        <li onClick={handleLogout} className={styles.logout}>
                                                Logout
                                        </li> 
                                    </ul>
                                    
                                </nav>)
                            : null
                        }
                        </ul>
                    </nav>
                </div>
            </header>
            
            <Outlet />
        </div>
    );
};

export default Layout;
